import { colors, fonts} from 'theme'
import { fontSizes } from 'theme/fonts'
import { image } from 'services'
import css from 'styled-jsx/css'

export default css.global`
.contact-footer-container {
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 100%;
  min-height: 28.12500rem;
  background-image: url(${image('/landing/contact/bg-contact-sillon.jpg')});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  padding-left: 50%;
}

h3 {
  max-width: 33.18rem;
  font: ${fonts.semiBold};
  font-size: ${fontSizes.h1};
  text-align: left;
  color: ${colors.text};
}

.success-message {
  width: 350px;
  height: 635px;
  text-align: center;
  display: flex;
  flex-direction: columns;
  align-items: center;
  justify-content: center;
}

.success-message h1 {
  color: ${colors.primary};
  font: ${fonts.semiBold};
  fontSizes: ${fontSizes.h1};
}
`;

